import React, { ReactElement } from "react";

import { ShieldIcon } from "../../components/Icons";
import { Tooltip } from "../../components/Tooltip";

/* Two-factor-authentication shield — the same indicator as the app's
   `User2FA` (ShieldIcon + Tooltip). Shared by the Users list and the User
   profile so the icon and its tooltip stay identical in one place. The shield
   uses its default muted `--color-theme-600` fill. */

export interface TwoFactorShieldProps {
  /** When true, 2FA isn't set up yet for the logged-in user: the shield is
   *  dimmed and clickable, and the tooltip prompts to enable it. Otherwise it
   *  reads as "enabled" (the default). Mirrors `isLoggedUser2FADisabled`. */
  needsSetup?: boolean;
  className?: string;
}

export const TwoFactorShield = ({
  needsSetup = false,
  className,
}: TwoFactorShieldProps): ReactElement => (
  <Tooltip
    title={
      needsSetup
        ? "Enable two-factor authentication"
        : "Two-factor authentication enabled"
    }
  >
    <ShieldIcon
      className={className}
      style={needsSetup ? { opacity: 0.5, cursor: "pointer" } : undefined}
    />
  </Tooltip>
);

TwoFactorShield.displayName = "TwoFactorShield";
